import React from 'react';
import { IOrderInfoDetails, ITypeVignettesOrderManagementFields } from '@adac-mp/shared';
import { Typography, IconPopup, PriceInformation, ProductOrderSummary, renderProductIcon } from '../index';

export const renderCancellationOverlay = (
	currOrderItem: IOrderInfoDetails,
	contenfulLabels?: ITypeVignettesOrderManagementFields,
) => {
	const {
		serviceCatalogName,
		supplierId,
		price,
		refundAmount,
		moduleTypeId,
		tollClass,
		moduleDetail,
		moduleDetailId,
	} = currOrderItem;
	const hasPartialCancellation =
		refundAmount?.decimalAmount > 0 &&
		refundAmount?.decimalAmount !== price.decimalAmount &&
		currOrderItem.supplierId === 3;
	const isFlexProduct = moduleTypeId === 4;
	const difference = price?.decimalAmount - refundAmount?.decimalAmount;

	const renderPartialCancellation = () => (
		<div className="bg-gray-600 rounded py-3 px-3.5">
			<div className="flex flex-col gap-3 mb-3">
				<Typography component="p" className="flex justify-between w-full" size="baseLg" color="title">
					{contenfulLabels?.originalPrice || 'Ursprünglicher Preis'}
					<Typography size="baseLg" color="title">{`${price.amount}€`}</Typography>
				</Typography>
				<div className="flex w-full justify-between">
					<Typography component="p" className="flex items-center gap-1" size="baseLg" color="title">
						{contenfulLabels?.userFee || 'Nutzungsgebühr'}
						<IconPopup
							bold
							type="info"
							title={contenfulLabels?.userFee || 'Nutzungsgebühr'}
							paddingX="large"
							paddingY="large"
							contentfulId="usageFee"
						/>
					</Typography>
					<Typography size="baseLg" color="title">{`-${difference
						.toFixed(2)
						.replace('.', ',')}€`}</Typography>
				</div>
			</div>
			<PriceInformation
				className="pt-3 border-t border-b-0 border-r-0 border-l-0 border-solid border-t-gray-500"
				totalPrice={{
					label: contenfulLabels?.refundLabel || 'Ihre Rückerstattung',
					amount: `${refundAmount.amount}€`,
					decimalAmount: refundAmount.decimalAmount,
				}}
			/>
		</div>
	);

	const renderCancelOverlayText = () => {
		if (hasPartialCancellation) {
			return (
				contenfulLabels?.partialRefundText?.replace('[product]', serviceCatalogName) ||
				`Schade, dass Sie Ihre Bestellung stornieren wollen. Der Gültigkeitszeitraum Ihrer ${serviceCatalogName} hat bereits begonnen. Aus diesem Grund wird Ihnen nur ein Teilbetrag des ursprünglichen Preises erstattet.`
			);
		}
		if (currOrderItem.supplierId === 3) {
			return isFlexProduct
				? contenfulLabels?.cancelFlexOverlayText || 'Wollen Sie diesen FLEX Service wirklich löschen?'
				: contenfulLabels?.cancelOverlayText ||
						'Schade, dass Sie Ihre Bestellung stornieren wollen. Die gute Nachricht: Es fallen keine weiteren Kosten für Sie an.';
		}
		return (
			contenfulLabels?.cancelationWithServiceFeeText ||
			'Schade, dass Sie Ihre Bestellung stornieren wollen. Sie bekommen den vollen Produktpreis, jedoch nicht die Servicegebühr rückerstattet. Es fallen keine weiteren Kosten für Sie an.'
		);
	};

	return (
		<>
			<Typography component="p" className="px-3 pb-3" size="lg" color="title">
				{renderCancelOverlayText()}
			</Typography>
			{!isFlexProduct && (
				<>
					{!hasPartialCancellation && (
						<Typography component="p" color="title" className="pl-3 mb-3">
							{contenfulLabels?.refundLabel || 'Ihre Rückerstattung'}:
						</Typography>
					)}
					{hasPartialCancellation ? (
						renderPartialCancellation()
					) : (
						<ProductOrderSummary
							simple
							className="mb-1.5"
							icon={renderProductIcon({ moduleTypeId, supplierId, tollClass })}
							title={serviceCatalogName}
							category={{
								moduleDetail,
								moduleDetailId,
							}}
							order={currOrderItem}
						/>
					)}
				</>
			)}
		</>
	);
};
